import PercentDiscountIcon from '@icons/PercentDiscountIcon';
import SoldOutIcon from '@icons/SoldOutIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { GoalSellingStatus } from 'lib/models/goals';
import { useLandingPageTranslation } from './useLandingPageTranslation';

interface GoalLandingPageSellingStatusBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  sellingStatus: GoalSellingStatus;
  withSubtitle?: boolean;
}

export default function GoalLandingPageSellingStatusBanner({
  sellingStatus,
  withSubtitle = true
}: GoalLandingPageSellingStatusBannerProps) {
  const { t } = useLandingPageTranslation();

  return (
    <>
      {sellingStatus === GoalSellingStatus.PRE_SALE && (
        <div
          className={classNames(
            'flex flex-col items-center justify-center gap-xs px-sm py-lg',
            'bg-gradient-to-r from-[#6EC29A] to-[#358C63]'
          )}
        >
          <div className='flex items-center gap-xs'>
            <PercentDiscountIcon size={28} className={classNames(setupForDark('text-white'))} />
            <h2
              className={classNames(
                'font-semibold leading-[1.4] uppercase',
                setupForDark('text-white'),
                'text-[20px] @[640px]:text-[24px]',
                'whitespace-normal @[640px]:whitespace-nowrap text-center'
              )}
            >
              {t('domains.goals.landingPage.preSaleBanner.title')}
            </h2>
          </div>

          {withSubtitle && (
            <div className='w-full max-w-[1200px] text-center'>
              <p className={classNames('P2R', setupForDark('text-white'), 'leading-[1.3]')}>
                {t('domains.goals.landingPage.preSaleBanner.subtitle')}
              </p>
            </div>
          )}
        </div>
      )}
      {sellingStatus === GoalSellingStatus.SOLD_OUT && (
        <div
          className={classNames(
            'flex flex-col items-center justify-center gap-xs px-sm py-lg',
            'bg-gradient-to-r from-[#F17B7B] to-[#CB4141]'
          )}
        >
          <div className='flex items-center gap-xs'>
            <SoldOutIcon size={28} className={classNames(setupForDark('text-white'))} />
            <h2
              className={classNames(
                'font-semibold leading-[1.4] uppercase',
                setupForDark('text-white'),
                'text-[20px] @[640px]:text-[24px]',
                'whitespace-normal @[640px]:whitespace-nowrap text-center'
              )}
            >
              {t('domains.goals.landingPage.soldOutBanner.title')}
            </h2>
          </div>

          {withSubtitle && (
            <div className='w-full max-w-[1200px] text-center'>
              <p className={classNames('P2R', setupForDark('text-white'), 'leading-[1.3]')}>
                {t('domains.goals.landingPage.soldOutBanner.subtitle')}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}
